import { PaginateQuery, PaginateResult } from "core/resources/types/shared";
import { useQuery } from "react-query";
import axios from "infra/http";
import { TenantUsuarioItem } from "../typings/tenant";
import { BaseFiltroPaginate } from "core/resources/enums/paginate";

export interface UseGetTenantUsuariosProps extends PaginateQuery {
  tenantId: string;
}

function useGetTenantUsuarios({
  tenantId,
  page = 1,
  limit = BaseFiltroPaginate.Limit,
  search = undefined,
}: UseGetTenantUsuariosProps) {
  return useQuery(
    [`/v1/tenants/${tenantId}/usuarios-${page}-${limit}-${search}`],
    async () => {
      const res = await axios.get<PaginateResult<TenantUsuarioItem>>(
        `/v1/tenants/${tenantId}/usuarios`,
        {
          params: {
            page,
            limit,
            search,
          },
        }
      );

      return res.data;
    }
  );
}

export default useGetTenantUsuarios;
